import '../css/app.css';

import { ErrorBoundary } from '@/lib/bugsnag';
import createLocalizedZiggy from '@/lib/localized-ziggy';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot, hydrateRoot } from 'react-dom/client';

// TODO: remove (workaround for https://github.com/inertiajs/inertia-laravel/issues/713)
if (!window.history.state) {
  window.history.replaceState({ scrollRegions: [] }, '');
}

createInertiaApp({
  title: (title) => title,
  resolve: (name) => resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx')),
  setup({ el, App, props }) {
    window.domain = new URL(props.initialPage.props.meta.url).hostname;
    window.isSubdomain = window.domain.includes('.boostbuddy');
    window.route = createLocalizedZiggy(props.initialPage.props.meta.url, props.initialPage.props.locale);

    const component = (
      <ErrorBoundary>
        <App {...props} />
      </ErrorBoundary>
    );

    if (import.meta.env.DEV) {
      createRoot(el).render(component);
    } else {
      hydrateRoot(el, component);
    }
  },
  progress: {
    color: '#032341',
  },
});
